<template>
  <div class="animated fadeIn">
   
    <b-row >
       
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Pallet Info</strong> 
             </div>



         <b-row>
          <b-col md="4">
                   <b-form-group label=" Select Pallet "  :label-cols="4" >
                    <b-form-select v-model="customer.pallet_id" id="customer.pallet_id" name="pallettitle" :class="{'input': true, 'text-danger': errors.has('form-1.pallet_title') }" v-on:change="Dashboardcall(customer.pallet_id); setpalletid();"  >
                        <option :value="0"  >--Select--</option>
                        <option  :value="customer.pallet_id" v-for="customer in data1">{{ customer.pallet_title }}</option>

                    </b-form-select> 

                    <span style="width: 270px;" v-show="errors.has('form-1.pallet_title')" class="help text-danger">{{ errors.first('form-1.pallet_title') }}</span>
                  </b-form-group>

            
                </b-col>
               
              </b-row>
           <!--   <b-row>
          
         <b-col md="12" class="my-1">
           
            <b-row class="form-group">

          

            </b-row>               
                         
          </b-col>   
              

              
            </b-row>  -->



            
           












          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Dashboard</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Detail</a>
              </li>
             
             
            </ul>
          </div>
           
          </b-col>
         
          <b-col md="12"  class="text-right">
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <palletinfodashboard style="width:70%;"></palletinfodashboard>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <palletinfolisting style="width:70%;"></palletinfolisting>
            </div>

           

     
        
             </b-col>

          </b-row> 
      

        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

import palletinfodashboard from './palletinfodashboard.vue'
import palletinfolisting from './palletinfolisting.vue'
import { EventBus } from "./event-bus.js";


export default {
  data: function() {
    return {
      activeTab: 1,
      palletinfodashboard,
      palletinfolisting,
      id:'',
      customer: {},
      customer1:{},
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      Count: 0  ,
      data1:[],
      data2:[],
      agentmaster: [],
      locationlist:[],
      zonenamelist:[],
      shipmentstatuslist:[],
      vendorlist:[],
      deliveryagentid:'',
      orderflow:'',
      locationid:'',
      vendorid:'',
     shipmenttype:'',
     selected:'',
     shipmentstatus:'',
      options: [],
      vendoroptions:[],
      statusoptions:[],
      locationoptions:[],
       zoneoptions:[],

      orderflowoptions:[
        
        { Id: 'forward', flow: 'Forward' },
        { Id: 'reverse', flow: 'Reverse' },
        
      ],
       shipmentoptions:[
        { Id: '3PL', status1: 'Fm' },
        { Id: 'vendor,warehouse', status1: 'Lm' },
        { Id: 'reverse', status1: 'RVp' },
        
      ],
      flowfields : { text: 'flow', value: 'Id' },
      statusfields:{text: 'status1', value: 'Id'},
      
      value2:[],
      value3:[],
      value4:[],
      value5:[],
      value6:[],
      value7:[],
      value8:[],

      allowCustomValue : true,

    fields: { text: 'name', value: 'id' },

        
      
      name: 'palletinfodashboard',
      showSelectAll : true
     
    };
  },
  components: {
   

    palletinfodashboard,
    palletinfolisting
   
  },
 
  created: function() {
      var palletids = JSON.parse(localStorage.getItem("palletid"));
    this.customer.pallet_id=palletids;
   
   // this.setSelecteddate();
     this.isActiveTab(1);
       this.getpalletlist();

   //  this.displaydeliveryagent();
    // this.location();
   // this.zone();

    // this.vendor();
    // this.shipment();
   
   
   
   

  },
 
  methods: {
 

     displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id: `${userInfo.pickuplocationmasterid.toString()}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
         name: this.agentmaster[i].deliveryagentmasterid+" - "+this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname,
        id: this.agentmaster[i].deliveryagentmasterid
      }
 this.options.push(deliveryagent2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },



     zone: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getzonename`)
        .then((result) => {
          this.zonenamelist = result.body
          // console.log("mmmmm"+this.zonenamelist.length);
          
          for(var i = 0; i < this.zonenamelist.length; i++) {
            var zone2 = {
        name: this.zonenamelist[i].zone_name,
        id: this.zonenamelist[i].zone_name,
      }
      // console.log("mmmmm"+this.zonenamelist.length);
 this.zoneoptions.push(zone2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },


    vendor: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getvendorlist`)
        .then((result) => {
          this.vendorlist  = result.body
                 for(var i = 0; i < this.vendorlist.length; i++) {
            var vendor2 = {
        name: this.vendorlist[i].vendor_name,
         id: this.vendorlist[i].vendor_name,
       
      }
 this.vendoroptions.push(vendor2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    getpalletlist: function () {

    //  alert("zone & pin codes");
    this.isBusy = true;
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
          
          const Obj = {
         
           hub_id: `${userInfo.pickuplocationmasterid.toString()}`,
            
           
          };
     
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getpalletrecordslisting`,Obj)
        .then((result) => {
          if (result.body.returnmsg="Successful") {
             this.data1  = result.body.returnvalue;
           
             
          } else {
            this.data1=[];
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    shipment: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getshipmentstatus`)
        .then((result) => {
          this.shipmentstatuslist  = result.body
           for(var i = 0; i < this.shipmentstatuslist.length; i++) {
            var shipmentstatus2 = {
        name: this.shipmentstatuslist[i].process,
        id: this.shipmentstatuslist[i].process,
      }
 this.statusoptions.push(shipmentstatus2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
   Dashboardcall(pid) {  
    // alert("count example");
   // this.Count++;  
      // Send the event on a channel (i-got-clicked) with a payload (the click count.)  
      EventBus.$emit("clicked-event", pid);  
      }  ,


setpalletid: function() { 
// alert("i m in pallet id task");



     
    
    
    var palletidarr=(this.customer.pallet_id!=null)? this.customer.pallet_id:"";
      // alert(palletidarr)
   
      localStorage.setItem("palletid", palletidarr);
     
    
      },


        formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },


 
  	isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },




  

};

</script>





